import { Apis } from "../../../lib/Apis";

const unwrapResponseBody = (body) => {
  if (body == null) return null;
  if (body?.success === false) {
    throw new Error(body?.message || "Request failed.");
  }
  if (
    body &&
    typeof body === "object" &&
    "data" in body &&
    ("success" in body || "statusCode" in body)
  ) {
    return body.data;
  }
  return body;
};

const unwrapList = (body) => {
  const payload = unwrapResponseBody(body) ?? body ?? {};
  if (Array.isArray(payload?.data)) return payload.data;
  if (Array.isArray(payload)) return payload;
  return [];
};

export const popularHouseDesign = () => {
  const addPopularHouseDesing = async (data) => {
    try {
      const response = await Apis.addPopularHouseDesign(data);
      return unwrapResponseBody(response?.data) ?? response?.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  };

  const getAllHouseDesing = async (setHouseDesingNames) => {
    try {
      const response = await Apis.getAllHouseDesignNames();
      const items = unwrapList(response?.data);
      setHouseDesingNames(items);
      return items;
    } catch (error) {
      console.error(error);
      throw error;
    }
  };

  return {
    addPopularHouseDesing,
    getAllHouseDesing,
  };
};
